import React from "react"
import { useNavigate } from "react-router-dom"
import ProfileMenu from "../ProfileMenu/ProfileMenu"
import { TimerIcon } from "lucide-react"

const sidebarMenuItems = [
  {
    key: "quick-launch-ads",
    label: "Quick Launch Ads",
    icon: "/rocket.svg",
    alt: "Rocket",
    route: "/quick-launch-ads",
  },
  {
    key: "launch-history",
    label: "Launch History",
    icon: "timer",
    alt: "History",
    route: "/launch-history",
  },
  {
    key: "ad-templates",
    label: "Ad Templates",
    icon: "/template.svg",
    alt: "Template",
    route: "/ad-templates",
  },
  {
    key: "sheet-ad-launcher",
    label: "Sheet Ad Launcher",
    icon: "/sheet.svg",
    alt: "sheet-ad-launcher",
    route: "/sheet-ad-launcher",
  },
  {
    key: "legacy-flow",
    label: "Back to Legacy Flow",
    icon: "/back-arrow.svg",
    alt: "legacy-flow",
    route: "/launch-new-ad",
  },
  {
    key: "settings",
    label: "Settings",
    icon: "/newsettings.svg",
    alt: "Settings",
    route: "/settings",
  },
]

const Sidebar = ({ user, activePath }) => {
  const navigate = useNavigate()

  const displayName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(" ")
    : ""
  const displayEmail = user && user.email ? user.email : ""
  const hasUserInfo = Boolean(displayName || displayEmail)

  function handleLinkClick(item) {
    navigate(item.route)
  }

  return (
    <div className="sidebar fixed top-[68px] left-0 w-[256px] h-[calc(100vh-68px)] bg-white border-r border-gray-200 flex flex-col justify-between overflow-hidden z-10">
      <div className="sidebar-header">
        <div className="px-3 mt-5 mb-4">
          <button
            className="flex items-center justify-center"
            style={{
              background: "#6E65ED",
              width: 232,
              height: 36,
              maxWidth: 800,
              gap: 8,
              borderRadius: 8,
              paddingTop: 8,
              paddingRight: 12,
              paddingBottom: 8,
              paddingLeft: 12,
              opacity: 1,
              fontFamily: "Inter, sans-serif",
              border: "none",
              cursor: "pointer",
              transition: "background 0.2s",
              textAlign: "center",
            }}
            onClick={() => navigate("/launch-new-ad")}
          >
            <span
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 400,
                fontStyle: "normal",
                fontSize: 14,
                lineHeight: "140%",
                letterSpacing: 0,
                color: "#fff",
                textAlign: "center",
                width: "100%",
                display: "block",
              }}
            >
              + Launch Ads
            </span>
          </button>
        </div>
        <ul className="space-y-[4px]">
          {sidebarMenuItems.map((item) => {
            const isActive = activePath === item.route
            return (
              <li className="px-3" key={item.key}>
                <div
                  className={`sidebar-menu-item flex items-center gap-3 h-10 rounded-[8px] cursor-pointer font-medium text-[14px] leading-[24px] tracking-[-0.01em]${
                    isActive ? "" : " bg-white"
                  } hover:bg-[#F1F2F3]`}
                  style={{
                    fontFamily: "Inter, sans-serif",
                    background: isActive ? "#F1F2F3" : undefined,
                  }}
                  onClick={() => handleLinkClick(item)}
                >
                  {item.icon === "timer" ? (
                    <TimerIcon className="w-5 h-5 mr-1 ml-[12px]" />
                  ) : (
                    <img
                      src={item.icon}
                      alt={item.alt}
                      className="w-5 h-5 mr-1 ml-[12px]"
                    />
                  )}
                  <span className="font-medium text-[14px] leading-[120%] tracking-[0em]">
                    {item.label}
                  </span>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
      <div className="sidebar-footer">
        <div style={{ width: "100%", height: 1, background: "#E5E7EB" }} />
        <ul className="space-y-1">
          <li className="p-3">
            <div className="sidebar-menu-item flex items-center gap-3 justify-between w-full h-[40px] rounded-[8px] cursor-pointer hover:bg-[#F1F2F3] p-3">
              {hasUserInfo ? (
                <ProfileMenu position="sidebar" />
              ) : (
                <div className="flex items-center justify-center w-10 h-10 text-white bg-gray-300 rounded-full" />
              )}
              <div className="flex flex-col items-start">
                <span
                  className="font-semibold text-[14px] leading-[140%]"
                  style={{
                    fontFamily: "Plus Jakarta Sans, sans-serif",
                    letterSpacing: 0,
                  }}
                >
                  {displayName}
                </span>
                <span className="text-xs text-gray-500">{displayEmail}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
